import { Injectable, signal } from "@angular/core";

/**
 * Shared open/closed state for the AI chatbot panel, so entry points outside ChatbotComponent
 * (e.g. the search bar's "Ask AI" pill) can open it.
 */
@Injectable({
  providedIn: "root",
})
export class ChatbotService {
  private readonly _isOpen = signal(false);
  readonly isOpen = this._isOpen.asReadonly();

  open(): void {
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }
}
